module.exports = __webpack_public_path__ + "img/1F1EE-1F1F4.553b7ceb.svg";